import React from 'react';
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {Button} from "primereact/button";

const ContextMenuView = (props) => {

    return (
        <React.Fragment>
            {props.isButton ?
                <Button label={props.label ? props.label : ""}
                        className={props.className ? props.className : "p-button-secondary"}
                        icon={props.icon ? props.icon : "pi pi-angle-down"}
                        iconPos={props.iconPos ? props.iconPos : "right"}
                        onClick={props.handleClick}/> :
                <Button onClick={props.handleClick}
                        icon={props.icon ? props.icon : "layout-topbar-icon pi pi-ellipsis-v"}
                        className={props.className ? props.className : "p-button-secondary"}/>
            }
            <Menu id="long-menu"
                  anchorEl={props.anchorEl}
                  open={Boolean(props.anchorEl)}
                  onClose={props.handleClose}>
                {
                    props.menuOptions.map(function (elem) {
                        return (
                            <MenuItem onClick={() => {
                                props.handleClose();
                                elem.action()
                            }}>
                                {elem.isBold ?
                                <b>{elem.label}</b> :
                                    elem.label
                                }
                            </MenuItem>);
                    })
                }
            </Menu>
        </React.Fragment>
    )
};
export default /*withStyles(styles)*/(ContextMenuView);
